import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const vulnerabilityIndicatorsRoutes: Routes = [
  {
    title: 'pagesTitles.vulnerabilityIndicators',
    path: APP_ROUTES.VULNERABILITY_INDICATORS,
    canActivate: [permissionGuard(APP_PERMISSIONS.VulnerabilityIndicatorsRead)],
    loadComponent: () =>
      import('./pages/vulnerability-indicators').then((m) => m.VulnerabilityIndicators),
  },
  {
    title: 'pagesTitles.vulnerabilityCalculation',
    path: APP_ROUTES.VULNERABILITY_CALCULATION,
    // Viewing the picker only needs read access; the Calculate action itself is additionally
    // gated at the component level by VulnerabilityCalculationCalculate.
    canActivate: [permissionGuard(APP_PERMISSIONS.VulnerabilityIndicatorsRead)],
    loadComponent: () =>
      import('./pages/vulnerability-calculation').then((m) => m.VulnerabilityCalculation),
  },
];
